/**
 * Справочник nsi.postal_services приходит плоским списком пар
 * «перевозчик (psCode) — услуга (psTypeCode)»: у одного перевозчика
 * несколько услуг (например, DPD -> CUR_AUTO, CUR_AVIA).
 */

const option = (code) => ({ label: code, value: code });

export const carrierOptions = (postalServices = []) =>
    [...new Set(postalServices.map(p => p.psCode))].sort().map(option);

/** Услуги выбранного перевозчика; без выбора — все услуги справочника. */
export const serviceOptions = (postalServices = [], psCode) => {
    const source = psCode ? postalServices.filter(p => p.psCode === psCode) : postalServices;
    return [...new Set(source.map(p => p.psTypeCode))].sort().map(option);
};
